import React from 'react'
import styles from './TextareaInput.module.scss'

interface TextareaInputProps {
  id?: string
  name?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  rows?: number
  disabled?: boolean
  error?: boolean
  className?: never
}

export const TextareaInput: React.FC<TextareaInputProps> = ({
  id, name, value, onChange, placeholder, rows = 4,
  disabled = false, error = false,
}) => (
  <textarea
    id={id}
    name={name}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    rows={rows}
    disabled={disabled}
    className={[styles.textarea, error ? styles.error : ''].filter(Boolean).join(' ')}
  />
)
